module.exports = __webpack_public_path__ + "assets/otc-liquidity-icon.15247e4e.svg";